import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import { NavigationCleanUpAction } from '../store/navigation.actions';
import { INavigationBarItemInterface } from '../interfaces';
import {
  selectNavigationItemCurrentSelectedFeature,
  selectNavigationListFeature
} from '@ispm/navigation/store/navigation.selector';
import { NavigationConfigService } from '@ispm/navigation/services/navigationConfig.service';
import { RouterManagerService } from '@ispm/core/services/router-manager.service';
import { PathwayPreviewService } from '@ispm/test/services/preview/pathway-preview.service';
import { APPLICATION_TYPE } from '../../../worklist/components/dashboard/constants/constants';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable()
export class NavigationService {
  private resourceType = '';

  constructor(
    private authService: AuthenticationService,
    private navigationConfigService: NavigationConfigService,
    private previewService: PathwayPreviewService,
    private store: Store<IgenomicsState>,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  get navigationResourceType() {
    return this.resourceType;
  }

  set navigationResourceType(value) {
    this.resourceType = value;
  }

  get onNavigation() {
    return this.store.pipe(map(selectNavigationItemCurrentSelectedFeature()));
  }

  get navigationItems(): Observable<Array<INavigationBarItemInterface>> {
    return this.store.pipe(map(selectNavigationListFeature()));
  }

  get selectedNavigationItem() {
    return this.store.pipe(map(selectNavigationItemCurrentSelectedFeature()));
  }

  public getStateSearchBar(currentApplication, appId: string) {
    const showPatientSearchBar = this.authService ? this.authService.doesUserHasPermission('SEARCH.PATIENT') : false;
    const isPathways = this.navigationConfigService.getCurrentApplicationType() === APPLICATION_TYPE.PATHWAY_NAVIGATOR;
    const isPreview = this.previewService.isDraftMode();
    const isCuration = this.router.routerState.snapshot.url.includes('curation') || isPreview;
    // const isCuration = this.routerManagerService.getState().url.includes('dashboard.curation') || isPreview;
    return (isPathways && showPatientSearchBar && !isCuration) || (!isPathways && !isCuration);
  }

  public getUrlParams(url) {
    return this.navigationConfigService.getUrlQueryParams(url);
  }

  public clearState() {
    // if current user is Admin
    if (this.authService && this.authService.user && this.authService.user.isAdmin === true && sessionStorage) {
      // reset the selected organization ID that is currently stored in the sessionStorage
      sessionStorage.removeItem('adminSelectOrganizationId');
      // we clear the state of the redux when press home or we in the admin somehow
      this.store.dispatch(new NavigationCleanUpAction());
      // make sure that authService.user.organization is set correctly (it might by changed over time by the current "adminSelectOrganizationId" value)
      this.authService.revertUserOriginalOrganization();
    }
  }

  public getCurrentApplicationId() {
    return this.navigationConfigService.getCurrentApplicationId();
  }
}
